import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Alert } from "./Alert";
import { 
  collection,
   doc,
   setDoc,
} from "firebase/firestore";

import { firestore } from '../firebase';

export function Register() {
  const { signup } = useAuth();

  const [user, setUser] = useState({
    name:"",
    email: "",
    password: "",
    company:"",
    phone:""
  });

  const [requestAccess, setRequestAccess] = useState({
    name:'',
    email:'',
    phone: ''
    })

  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e,) => {
    e.preventDefault();
    setError("");
    try{
      const usersRef = collection(firestore, "users");
      await setDoc(doc(usersRef),{
        nombre: user.name,
        correo: user.email,
        password: user.password,
        phone: user.phone,
        company: user.company,
      });
      navigate("/thanks")
    }
    catch(error){
      setError(error.message)
    }

    // try {
    //   await signup(user.email, user.password, user.name);
    //   // navigate("/thanks");
    // } catch (error) {
    //   setError(error.message);
    // }
  };

  return (
    <div>
    {error && <Alert message={error} />}


    			<div className="text-md-left offset-lg-0 column-padding col-lg-5 col-md-11 offset-md-0">
				<form id="acceso_a_catalogo" data-form-type="blocs-form" noValidate data-success-msg="Your message has been sent." data-fail-msg="Sorry it seems that our mail server is not responding, Sorry for the inconvenience!" onSubmit={handleSubmit}>
					<div className="form-group">
						<h2 className="mg-md h2-style">
							sign in to get access <span className="text-span-bloc-5-style">to our entire catalog</span>
						</h2>
						<input id="name" className="form-control form-style" required placeholder="Name" onChange={(e) => setUser({ ...user, name: e.target.value })} />
					</div>
          <div className="form-group">
						<input id="company" type="text" className="form-control form-style" placeholder="Company" onChange={(e) => setUser({ ...user, company: e.target.value })} />
					</div>
          <div className="form-group">
						<input id="phone" type="tel" className="form-control form-style" placeholder="Phone" onChange={(e) => setUser({ ...user, phone: e.target.value })} />
					</div>
					<div className="form-group">
						<input id="email" className="form-control form-style" type="email" data-error-validation-msg="Not a valid email address" required placeholder="Email" onChange={(e) => setUser({ ...user, email: e.target.value })} />
					</div> 
					<div className="form-group">
						<input id="password" type="password" className="form-control form-style" placeholder="Password" onChange={(e) => setUser({ ...user, password: e.target.value })} />
					</div>
					<button className="bloc-button btn btn-black btn-black btn-rd float-lg-right float-md-right float-sm-right float-right" >
						Request access
					</button>
				</form>
			</div>
    </div>
  );
}
